import * as bk02 from '../actions/bk02.actions';

export interface State {
    BK02_04;
    BK02_05;
    BK02_06;
    BK02_07;
    BK02_08;
    BK02_09;
    BK02_10;
    BK02_11;
    BK02_12;
    BK02_13;
    BK02_14;
    BK02_15;
}
export const initialState = {
    BK02_04: [],
    BK02_05: [],
    BK02_06: [],
    BK02_07: [],
    BK02_08: [],
    BK02_09: [],
    BK02_10: [],
    BK02_11: [],
    BK02_12: [],
    BK02_13: [],
    BK02_14: [],
    BK02_15: []
};

export function reducer(state = initialState, action: bk02.Actions) {
  switch (action.type) {
    case bk02.GO_TO_PAGE_BK02: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        ...data
      });
    }
    default:
      return state;
  }
}

function transformResponse(data) {
    return {
        BK02_04: pdfList(data[0].pdfFilesInfo),
        BK02_05: pdfList(data[1].pdfFilesInfo),
        BK02_06: pdfList(data[2].pdfFilesInfo),
        BK02_07: pdfList(data[3].pdfFilesInfo),
        BK02_08: pdfList(data[4].pdfFilesInfo),
        BK02_09: pdfList(data[5].pdfFilesInfo),
        BK02_10: pdfList(data[6].pdfFilesInfo),
        BK02_11: pdfList(data[7].pdfFilesInfo),
        BK02_12: pdfList(data[8].pdfFilesInfo),
        BK02_13: pdfList(data[9].pdfFilesInfo),
        BK02_14: pdfList(data[10].pdfFilesInfo),
        BK02_15: pdfList(data[11].pdfFilesInfo)
    };
}

function pdfList(pdfArray) {
    return pdfArray.map(e => {
        return {
            fileName: e.fileName,
            filePath: e.filePath
        };
    });
}
